import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {
  currentUser: any;
  username: string;
  currentUserSubscription: Subscription;

  constructor(
    public router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user;
        this.username = this.currentUser.data.user.username;
      }
    );
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard']);
    }
  }

  eliminarCache() {
    localStorage.removeItem('credentials');
    localStorage.removeItem('userroles');
    localStorage.removeItem('currentUser');

    this.router.navigate(['/login']);
  }
}
